import * as React from 'react';
import { LinkButton, UIText1 } from '@cian/ui-kit';
import cx from 'clsx';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DEFAULT_TITLE = 'Помощь риелтора';
var DEFAULT_TEXT = 'Проверенный риелтор поможет купить или продать квартиру';
var DEFAULT_BUTTON_TEXT = 'Оставить заявку';
export var RealtorRequestTrapV3 = function RealtorRequestTrapV3(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? DEFAULT_TITLE : _ref$title,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? DEFAULT_TEXT : _ref$text,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? DEFAULT_BUTTON_TEXT : _ref$buttonText,
    onClick = _ref.onClick,
    href = _ref.href,
    withoutBorders = _ref.withoutBorders,
    openBlank = _ref.openBlank;
  return /*#__PURE__*/_jsx("div", {
    className: cx(styles['root'], withoutBorders && styles['no-borders']),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['content'],
      children: [/*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(UIText1, {
          fontWeight: "bold",
          children: title
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['text'],
        children: /*#__PURE__*/_jsx(UIText1, {
          color: "black_100",
          children: text
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles['action'],
        children: /*#__PURE__*/_jsx(LinkButton, {
          theme: "fill_secondary",
          size: "XS",
          href: href,
          onClick: onClick,
          target: openBlank ? '_blank' : undefined,
          "data-testid": "realtor_request_trap_link",
          children: buttonText
        })
      })]
    })
  });
};
RealtorRequestTrapV3.displayName = 'RealtorRequestTrapV3';